import { z } from 'my-zod'

export const normalizedAddressModel = z.object({
  customerId: z.string(),
  addressLine1: z.string().nullable(),
  addressLine2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postalCode: z.string().max(15).nullable(),
  country: z.string().nullable()
})

export type normalizedAddressModel = z.infer<typeof normalizedAddressModel>
